<!-- <header id="header" class="header">
  <nav class="navbar fixed-top navbar-expand-lg scrolling-navbar offlinenavbgColor z-depth-5">
    <div class="float-left">
      <a href="" data-activates="slide-out" class="button-collapse">
        <i class="fas fa-bars fa-lg offlinebar"></i></a>
    </div>
    <img class="offlinelogo navbar-brand" href="" src="./assets/Images/offline/Accenture-Logo.png">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto no-margin">
        <li class="nav-item  waves-light offlineheaderDesc" mdbWavesEffect>
          <span>
            <a class="offlinenav-linkCompany  text-uppercase" href="#">
              <strong>{{CompanyTitle}}</strong>
              <span class="sr-only">(current)</span></a>
          </span>

        </li>
      </ul>
      <ul class="navbar-nav ml-auto nav-flex-icons">
        <li class="offlinenav-item mr-1">
          <a class="offline-Ulink mt-3" href="#">
            Hi, <strong>{{UserName}}</strong></a>
        </li>
        <li class="offlinenav-item dropdown">
          <a class="offline-link dropdown-toggle" id="navbarDropdownMenuLink-333" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img class="offlineuser navbar-brand" href="" src="./assets/Images/offline/user.jpg">
            
          </a>
          <div class="dropdown-menu dropdown-menu-right dropdown-default  align-items-center" aria-labelledby="navbarDropdownMenuLink-333">
            <a class=" d-flex align-items-center">
              <i class="fas fa-sign-out-alt iconColor margin"></i>
              <a class="active" (click)="logOut()">
                <h6><span>LogOut</span> </h6>
              </a>
            </a>
          </div>
        </li>

      </ul>
    </div>
  </nav>
</header> -->

<header id="header" class="header" *ngIf="showPortalUI">
  <nav class="navbar fixed-top navbar-expand-lg scrolling-navbar navbgColor">
    <img class="logo navbar-brand" href="" src="./assets/Images/Header/Accenture1.png">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto no-margin">
        <li class="nav-item  waves-light headerDesc" mdbWavesEffect>
          <span>
            <a class="nav-linkCompany  text-uppercase text-white" href="#">
              <strong>{{CompanyTitle}}</strong>
              <span class="sr-only">(current)</span></a>
          </span>

        </li>
      </ul>
      <ul class="navbar-nav ml-auto nav-flex-icons">


        <li class="nav-item">
          <a class="nav-link mt-2" text-white href="#">
            Hi, <strong>{{UserName}}</strong></a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink-333" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <mdb-icon fas icon="user" style="font-size:xx-large;"></mdb-icon>
          </a>
          <div class="dropdown-menu dropdown-menu-right dropdown-default  align-items-center" aria-labelledby="navbarDropdownMenuLink-333">      
            
        

    

         


          

          

            
            <a class=" d-flex align-items-center">
              <i class="fas fa-sign-out-alt iconColor margin"></i>
              <a class="alink active"
              (click)="logOut()">
              <h6><span>LogOut</span> </h6>
            </a>
            </a> 
          </div>
        </li>

      </ul>
    </div>
  </nav>
</header>

<section id="offline" class="offline section-bg">
  <div class="container" data-aos="fade-up">

    <div class="offlinesection-title mt-3 ml-3">
      <h2>Offline Reports</h2>
    </div>
    <div class="row offlinerow" data-aos="zoom-in" data-aos-delay="150">
      <div class="col-xl-12 col-xl-12">
        <div class="card shadow mb-4">

          <div class="card-body">
            <div class="divDataUnavailable" *ngIf="!DataAvaialble">
              <label><b>DATA UNAVAILABLE</b></label>
            </div>
            <div class="d-flex justify-content-center">
              <div class="spinner-grow offlinetext-secondary" role="status" *ngIf="loading">
                <span class="sr-only ">Loading...</span>

              </div>
            </div>


            <div [hidden]="!hasData">
              <div class="form-inline md-form form-sm formSearch">
                <mdb-icon fas icon="search" aria-hidden="true" class="searchicon"></mdb-icon>
                <input class="form-control form-control-sm ml-3 w-45" type="text" (keyup)="applyFilter($event)" placeholder="Filter" aria-label="Search" mdbInput>
              </div>


              <div class="mat-elevation-z8 z-depth-5 ">
                <mat-table class="" [dataSource]="offlineListMatTabDataSource" matSort 
                 matSortActive="report_Type"
                 matSortDirection="asc" matSortDisableClear>
                  <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef>No</mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index;">
                      {{i+1}}
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="User_ID">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> User</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.User_ID}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="Application">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Application </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.Application}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="Client_ID">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Client </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.Client_ID}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="Project_ID">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Project </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.Project_ID}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="Report_Type">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Report Type </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.Report_Type}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="SelectedReports">
                    <mat-header-cell *matHeaderCellDef> Selected Reports</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.SelectedReports}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="CreatedDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Created Date</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.CreatedDate}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="Remarks">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Status</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.Remarks}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="downloadFileName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Download</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="downloadcell">
                      <div *ngIf="element.Remarks=='Completed'; then thenBlock; else elseBlock"></div>
                      <ng-template #thenBlock>

                        <i class="fas fa-download fa-lg dowload " type="button" aria-hidden="true" (click)="downloadFile(element.downloadFileName)"></i>
                      </ng-template>
                      <ng-template #elseBlock>
                        {{element.downloadFileName}}
                      </ng-template>
                    </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
                <div id="filedownloadsuccess" class="toast-alert alert-info hide mt-3 " role="alert" 
                                                            aria-live="assertive" aria-atomic="true" data-autohide="false" *ngIf="showFileDownloadInfo">
                                                                  
                                                                  <div class="toast-body">
                                                                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                                                                        {{alertMsg}}
                                                                  </div>
                                                            </div>
              
                <div class="container">
                  <mat-paginator [pageSize]="5" [pageSizeOptions]="[5,10, 15]" showFirstLastButtons class="pb-3"></mat-paginator>
                </div>




              </div>

            </div>


          </div>

        </div>
      </div>
    </div>
    
  </div>
</section>

